
import React from 'react'

 const Orange = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56.13" height="64.894" viewBox="0 0 56.13 64.894">
    <g id="Group_18788" data-name="Group 18788" transform="translate(-171.334 -357.835)">
      <g id="Group_18787" data-name="Group 18787">
        <g id="Group_18786" data-name="Group 18786">
          <g id="Group_18784" data-name="Group 18784">
            <path id="Path_19899" data-name="Path 19899" d="M195.716,375.426c6.4-.315,21.285,2.957,24.931,17.541s-8.672,29.563-24.044,29.76-26.016-13.894-25.228-24.931S181.722,376.116,195.716,375.426Z" fill="#e79e0e"/>
          </g>
          <g id="Group_18785" data-name="Group 18785">
            <path id="Path_19900" data-name="Path 19900" d="M180.548,388.492c-.57,2.4,1.132,4.154,3.5,3.576a7.948,7.948,0,0,0,5.32-5.392c.57-2.4-.888-3.879-3.256-3.3S181.118,386.091,180.548,388.492Z" fill="#e7890e"/>
            <path id="Path_19901" data-name="Path 19901" d="M184.322,396.181a1.18,1.18,0,0,0,1.486,1.518,3.376,3.376,0,0,0,2.257-2.288c.242-1.019-.376-1.646-1.381-1.4A3.364,3.364,0,0,0,184.322,396.181Z" fill="#e7890e"/>
          </g>
          <path id="Path_19902" data-name="Path 19902" d="M198.572,371.557c-.092.178,3.328,3.262,9.986,3s15.311-13.647,18.906-14.579a45.126,45.126,0,0,0-11.983-2.131C208.757,357.577,202.366,364.234,198.572,371.557Z" fill="#548b37"/>
        </g>
        <path id="Path_19903" data-name="Path 19903" d="M192.9,377.156c0,.413,1.094.747,2.442.747s2.442-.334,2.442-.747-1.093-.748-2.442-.748S192.9,376.743,192.9,377.156Z" opacity="0.2"/>
      </g>
      <path id="Path_19904" data-name="Path 19904" d="M196.528,377.126a26.741,26.741,0,0,1,.458-6.7,16.569,16.569,0,0,1,2.417-4.312,4.25,4.25,0,0,0-.294-1.275c-.13-.2-2.025,1.34-2.548,2.287a43.6,43.6,0,0,0-2.287,9.638S194.666,377.714,196.528,377.126Z" fill="#596e39"/>
      <path id="Path_19905" data-name="Path 19905" d="M204.7,368.162s-6.857,4.128-8.721,5.659l-.066-1.4A93.117,93.117,0,0,1,204.7,368.162Z" fill="#596e39"/>
    </g>
  </svg>

  );
};
export default Orange
